/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_proyecto from './../UI/icons/Sidebar/Autoayuda.svg'
import i_proyecto2 from './../UI/icons/Sidebar/Autoayuda_White.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_lobby1 from './../UI/icons/Amenities/Porteria.svg'
import i_lobby12 from './../UI/icons/Amenities/Porteria White.svg'
import i_lobby from './../UI/icons/Amenities/Porteria 2.svg'
import i_lobby2 from './../UI/icons/Amenities/Porteria 21.svg'
import i_juegosInfantiles from './../UI/icons/Amenities/Juegos infantiles.svg'
import i_juegosInfantiles2 from './../UI/icons/Amenities/Juegos infantiles_White.svg'
import i_terraza from './../UI/icons/Amenities/Terraza.svg'
import i_terraza2 from './../UI/icons/Amenities/Terraza_White.svg'
import i_yoga from './../UI/icons/Amenities/Yoga.svg'
import i_yoga2 from './../UI/icons/Amenities/Yoga_White.svg'
import i_mascotas from './../UI/icons/Amenities/Mascotas.svg'
import i_mascotas2 from './../UI/icons/Amenities/Mascotas White.svg'
import i_mirador from './../UI/icons/Amenities/Mirador.svg'
import i_mirador2 from './../UI/icons/Amenities/Mirador_White.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ_white.svg'
import i_calistenia from './../UI/icons/Amenities/biosaludable.svg'
import i_calistenia2 from './../UI/icons/Amenities/biosaludable_White.svg'
import i_reuniones from './../UI/icons/Amenities/Salon de reuniones.svg'
import i_reuniones2 from './../UI/icons/Amenities/Salon de reuniones_WHite.svg'
import i_salonn2 from './../UI/icons/Amenities/Salon 2_WHite.svg'
import i_salonn from './../UI/icons/Amenities/Salon 2.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_gym2 from './../UI/icons/Amenities/Gym_white.svg'
import i_coworking from './../UI/icons/Amenities/Coworking.svg'
import i_coworking2 from './../UI/icons/Amenities/Coworking_white.svg'
import i_salaMultiple from './../UI/icons/Amenities/SalaMultiple.svg'
import i_salaMultiple2 from './../UI/icons/Amenities/SalaMultiple_White.svg'
import i_salaLudica from './../UI/icons/Amenities/SalonparaNinos.svg'
import i_salaLudica2 from './../UI/icons/Amenities/SalonparaNinos_white.svg'
import i_football from './../UI/icons/Amenities/Cancha.svg'
import i_football2 from './../UI/icons/Amenities/Cancha_White.svg'
import i_terrazaContemplativa from './../UI/icons/Amenities/Terraza Contemplativa.svg'
import i_terrazaContemplativa2 from './../UI/icons/Amenities/Terraza Contemplativa_White.svg'
import i_muro2 from './../UI/icons/Amenities/MuroWhite.svg'
import i_muro from './../UI/icons/Amenities/Muro.svg'



/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte2.svg'
import i_otros from './../UI/icons/POI/Otros2.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'Ayuda Ventas': i_proyecto,
    'Ayuda Ventas2': i_proyecto2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Portería 1': i_lobby1,
    'Portería 12': i_lobby12,
    'Portería 2': i_lobby,
    'Portería 22': i_lobby2,
    'Juego de niños': i_juegosInfantiles,
    'Juego de niños2': i_juegosInfantiles2,
    'Terraza': i_terraza,
    'Terraza2': i_terraza2,
    'Yoga': i_yoga,
    'Yoga2': i_yoga2,
    'BBQ': i_bbq,
    'BBQ2': i_bbq2,
    'Mascotas': i_mascotas,
    'Mascotas2': i_mascotas2,
    'Mirador': i_mirador,
    'Mirador2': i_mirador2,
    'Calistenia': i_calistenia,
    'Calistenia2': i_calistenia2,
    'Salón de reuniones': i_reuniones,
    'Salón de reuniones2': i_reuniones2,
    'Salón 2': i_salonn,
    'Salón 22': i_salonn2,
    'Gimnasio': i_gym,
    'Gimnasio2': i_gym2,
    'Área coworking': i_coworking,
    'Área coworking2': i_coworking2,
    'Sala uso múltiple': i_salaMultiple,
    'Sala uso múltiple2': i_salaMultiple2,
    'Sala lúdica infantes': i_salaLudica,
    'Sala lúdica infantes2': i_salaLudica2,
    'Indoor football': i_football,
    'Indoor football2': i_football2,
    'Terraza contemplativa': i_terrazaContemplativa,
    'Terraza contemplativa2': i_terrazaContemplativa2,
    'Muro Escalada': i_muro,
    'Muro Escalada2': i_muro2,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Educación": i_colegios,
    "Educación2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}